import { Hint } from '@/components/prototype/hint';
import { formatRelativeTime } from '@/lib/format';
import { exactTime } from '@/lib/time-labels';

/*
 * A relative timestamp with the exact moment behind it on hover - "2 days ago"
 * answers "is this fresh?" at a glance, the tooltip answers "when exactly?".
 * The activity feed has its own compact variant ("2d ago", tinted per row);
 * this is the one for ordinary body text.
 */
interface RelativeTimeProps {
  /** The moment itself; the tooltip is built from it. */
  iso: string | null | undefined;
  /**
   * Visible text, for payloads that arrive already humanised. Omit it for a
   * label computed here, which keeps ticking while the tab sits open. An
   * explicit null renders nothing - a live game has no "when" yet.
   */
  label?: string | null;
  className?: string;
}

export function RelativeTime({ iso, label, className }: RelativeTimeProps) {
  const text = label === undefined ? formatRelativeTime(iso) : label;
  if (!text) return null;

  return (
    <Hint label={exactTime(iso ?? null)}>
      <span className={className}>{text}</span>
    </Hint>
  );
}
